<br>
<!--div *ngIf="!showMailView" class="form-row btntop col-sm-12" style="margin-top: 10px;">
  <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="expanded = !expanded;expandedlabel==='Stäng grupper'? expandedlabel='Öppna grupper' : expandedlabel='Stäng grupper'">{{expandedlabel}}</button>
      </td>
    </tr>
  </table>
  <p class="reportlabel">Rapport: Utmärkelser (Grader/Tecken)</p>
</div-->

<div *ngIf="!showMailView" class="form-row btntop d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" (click)="search()">Sök</button>
        <button class="btn border" (click)="clear()">Rensa</button>
        <button class="btn border" (click)="expanded = !expanded; expandedlabel = expandedlabel === 'Stäng grupper' ? 'Öppna grupper' : 'Stäng grupper'">{{ expandedlabel }}</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Utmärkelser (Grader/Tecken)</p>

    </div>
  </div>
</div>
<div *ngIf="!showMailView" class="col-sm-11 ms-4 me-4">
  <div class="row">
    <div class="col-xs-12 col-md-5 col-xl-5">
      <form [formGroup]="signreportform" (keydown.enter)="search()">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Utmärkelse
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="signTypeId">
                Teckentyp
              </label>
              <select class="form-control form-control-sm" id="signTypeId" formControlName="signTypeId" (change)="getSignsBySignType($event, 'signlist')">
                <option></option>
                <option *ngFor="let st of signtypelist" [value]="st.id">{{st.name}}</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="signId">
                Utmärkelse
              </label>
              <select class="form-control form-control-sm" id="signId" formControlName="signId">
                <option></option>
                <option *ngFor="let s of signlist" [value]="s.id">{{s.name}} &nbsp; [{{s.abbreviation}}]</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="notSignTypeId">
                ICKE Teckentyp
              </label>
              <select class="form-control form-control-sm" id="notSignTypeId" formControlName="notSignTypeId" (change)="getSignsBySignType($event, 'notsignlist')">
                <option></option>
                <option *ngFor="let st of signtypelist" [value]="st.id">{{st.name}}</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="notSignId">
                ICKE Utmärkelse
              </label>
              <select class="form-control form-control-sm" id="notSignId" formControlName="notSignId">
                <option></option>
                <option *ngFor="let s of notsignlist" [value]="s.id">{{s.name}} &nbsp; [{{s.abbreviation}}]</option>
              </select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                 Erhållet i någon av:
                  <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Välj institutioner"
                          (click)="displayInstitutions=true;">
                    <i class="fa fa-plus"></i>
                  </button>
                  <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Rensa valda institutioner" (click)="selectedsigninstitutions=[]">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="col-md-4">
                  <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                    <tr *ngFor="let x of selectedsigninstitutions">
                      <td>{{x.name}}</td>
                      <td align="right">
                        <i class="fa fa-times" (click)="removeSelectedSignInstitution(x.id)" title="Ta bort vald institution"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-12">
                  Under perioden:
                  <p-datepicker id="signPeriodFrom" formControlName="signPeriodFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>&nbsp;
                  <p-datepicker id="signPeriodTo" formControlName="signPeriodTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              E-post
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-6">
              Epost1:<br>
              <p-selectButton [options]="epost" formControlName="email1"></p-selectButton>
            </div>
            <br>
            <div class="col-md-6">
              Epost2:<br>
              <p-selectButton [options]="epost" formControlName="email2"></p-selectButton>
            </div>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <div class="col-md-6">
      <form [formGroup]="signreportform" (keydown.enter)="search()">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlemskap
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-12">
              <br>
              <div class="row">
                <div class="col-md-4">
                  Medlemskap i <br>
                  <p-selectButton [options]="someorall" formControlName="membershipSomeOrAll"></p-selectButton>
                </div>
                <div class="col-md-2">
                  <br>
                  <div class="row">
                    <button *ngIf="signreportform.get('membershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;margin-bottom:25px;margin-left:4px;" (click)="displayMembership=true;">
                      <i class="fa fa-plus"></i>
                    </button>
                    <button *ngIf="signreportform.get('membershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;margin-bottom:25px;margin-left:4px;" title="Rensa valda institutioner" (click)="membershipselectedinstitutions=[]">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="col-md-5">
                  <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                    <tr *ngFor="let x of membershipselectedinstitutions">
                      <td>{{x.name}}</td>
                      <td align="right">
                        <i class="fa fa-times" (click)="removeMembershipSelectedInstitution(x.id)" title="Ta bort vald institution"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>
                    Medlemskap påbörjades mellan
                  </label>
                </div>
                <div class="form-group col-md-6">
                  <div class="form-check-inline">
                    <p-datepicker id="membershipStartedFrom" formControlName="membershipStartedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="membershipStartedTo" formControlName="membershipStartedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>
                    <button class="btn btn-primary" style="margin-left:10px;" (click)="setDate('membershipStartedTo', 'membershipEndedFrom')">
                      Just nu
                    </button>
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>
                    Medlemskap avslutades mellan
                  </label>
                </div>
                <div class="form-group col-md-6">
                  <div class="form-check-inline">
                    <p-datepicker id="membershipEndedFrom" formControlName="membershipEndedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="membershipEndedTo" formControlName="membershipEndedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" style="border-top:1px solid lightgrey;">
              <br>
              <div class="row">
                <div class="col-md-4">
                  Icke medlemskap i <br>
                  <p-selectButton [options]="someorall" formControlName="nomembershipSomeOrAll"></p-selectButton>
                </div>
                <div class="col-md-2">
                  <br>
                  <div class="row">
                    <button *ngIf="signreportform.get('nomembershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;margin-bottom:25px;margin-left:4px;" (click)="displayNoMembership=true;">
                      <i class="fa fa-plus"></i>
                    </button>
                    <button *ngIf="signreportform.get('nomembershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;margin-bottom:25px;margin-left:4px;" title="Rensa valda institutioner" (click)="nomembershipselectedinstitutions=[]">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="col-md-5">
                  <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                    <tr *ngFor="let x of nomembershipselectedinstitutions">
                      <td>{{x.name}}</td>
                      <td align="right">
                        <i class="fa fa-times" (click)="removeNoMembershipSelectedInstitution(x.id)" title="Ta bort vald institution"></i>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>
                    Medlemskap påbörjades mellan
                  </label>
                </div>
                <div class="form-group col-md-6">
                  <div class="form-check-inline">
                    <p-datepicker id="nomembershipStartedFrom" formControlName="nomembershipStartedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="nomembershipStartedTo" formControlName="nomembershipStartedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>
                    <button class="btn btn-primary" style="margin-left:10px;" (click)="setDate('nomembershipStartedTo', 'nomembershipEndedFrom')">
                      Just nu
                    </button>
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>
                    Medlemskap avslutades mellan
                  </label>
                </div>
                <div class="form-group col-md-6">
                  <div class="form-check-inline">
                    <p-datepicker id="nomembershipEndedFrom" formControlName="nomembershipEndedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="nomembershipEndedTo" formControlName="nomembershipEndedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
  </div>
</div>
<br>
<div *ngIf="!showMailView && result?.length > 0">
  <div class="resultdiv ms-2 me-2" style="margin-top:-6px;">
    <p-menubar [model]="items">
      <div class="d-flex justify-content-end align-items-center gap-2">
        <span *ngIf="result?.length === 2000" class="mx-4"><span class="badge badge-warning" style="font-size:14px;">Sökningen ger fler än 2000 träffar. Förfina filtren.</span></span>
        <span>Resultat: {{result?.length}}</span>
         <span>Välj alla:
           <mat-checkbox #checkAll (change)="checkuncheckAll(checkAll);"></mat-checkbox>
         </span>
     </div>
      </p-menubar>
    <table matSort class="table table-bordered" (matSortChange)="sortData($event)" matSortDisableClear=true>
      <thead role="rowgroup">
        <tr>
          <th mat-sort-header="memberId">Nr</th>
          <th mat-sort-header="givenName">Förnamn</th>
          <th mat-sort-header="familyName">Efternamn</th>
          <th mat-sort-header="institutionShortName">Inst.</th>
          <th mat-sort-header="signInstitutionShortName">Grad Inst.</th>
          <th mat-sort-header="institutionName">Inst. Namn</th>
          <th mat-sort-header="institutionSeat">Ort</th>
          <th mat-sort-header="signName">Utmärkelse</th>
          <th mat-sort-header="signTypeName">Typ</th>
          <th mat-sort-header="date">Datum</th>
          <th mat-sort-header="email" style="width:50px;">Välj</th>
        </tr>
      </thead>
      <tr *ngFor="let r of result">
        <td style="text-align: right;">
          <a [routerLink]="['/memberform/id/', r.memberInfo.id]">{{r.memberInfo.id}}</a>
        </td>
        <td>{{r.memberInfo.givenName}}</td>
        <td>{{r.memberInfo.familyName}}</td>
        <td>{{r.memberInfo.primaryInstitution?.shortName}}</td>
        <td>{{r.institutionShortName}}</td>
        <td><a [routerLink]="['/institutions/id/', r.institutionId]" title="Titta på institutionsdetaljer">{{r.insitutionName}}</a></td>
        <td>{{r.institutionSeat}}</td>
        <td>{{r.signName}}</td>
        <td>{{r.signTypeName}}</td>
        <td>{{r.date | date:'yyyy-MM-dd'}}</td>
        <td>
          <div class="d-flex justify-content-start gap-2 align-items-center">
            <mat-checkbox *ngIf="r.primaryInstitution!=='AV1'" #inputEl1 (change)="add(r, inputEl1);" [checked]="r.checked"></mat-checkbox><i *ngIf="r.email1 && r.primaryInstitution!=='AV1'" class="fa fa-envelope-o mt-2" aria-hidden="true"></i>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
<br />
<div *ngIf="showMailView">
  <app-mail [memberlist]=selectedmembers (closeEmail)="closeEmail($event)"></app-mail>
</div>

<p-dialog header="Institution" [(visible)]="displayInstitutions" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="selectedsigninstitutions" [form]="signreportform" (institutionSelected)="setSelectedInstitutions($event, 'sign')"></app-institution-chooser>
</p-dialog>

<p-dialog header="Medlemskap i" [(visible)]="displayMembership" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="membershipselectedinstitutions" [form]="signreportform" (institutionSelected)="setSelectedInstitutions($event, 'membership')"></app-institution-chooser>
</p-dialog>

<p-dialog header="Icke medlemskap i" [(visible)]="displayNoMembership" [modal]="true" [style]="{width: '50vw'}"
          [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="nomembershipselectedinstitutions" [form]="signreportform"
                           (institutionSelected)="setSelectedInstitutions($event, 'nomembership')"></app-institution-chooser>
</p-dialog>

<!--pre>{{signreportform.value | json}} </pre-->

<!--button class="btn border" (click)="GetMemberInfoFromMemberIds()">GetMemberInfoFromMemberIds</button-->

<!--pre>{{result|json}}</pre-->
